module.exports = __webpack_public_path__ + "static/media/foto4.c5caf2dc.jpeg";